import { bool, func, oneOf, string } from 'prop-types';
import React, { Component } from 'react';

import { wrongSKUsError } from '../../../generic/flash-messages/utils';
import { getTooltipButtonWithText } from '../../../generic/Tooltip';
import { highlightedSkusShape } from '../../../prop-types';
import FEATURE_FLAGS, { useSafeFlag } from '../../../utils/flags';
import WrongSKUsActionModal from '../../CampaignPushButton/WrongSKUsActionModal';
import { campaignLineStatuses, wrongSKUsErrorMessage } from '../../constants';
import HELP_TEXTS from '../../utils/help-texts';

const { DRAFT, READY } = campaignLineStatuses;
const ButtonWithTooltip = getTooltipButtonWithText(HELP_TEXTS);

export class ProductStatusChangeButtonClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showWrongSKUsModal: false,
      wrongSKUsError: undefined,
    };
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleWrongSKUsDismiss = this.handleWrongSKUsDismiss.bind(this);
    this.handleWrongSKUsConfirm = this.handleWrongSKUsConfirm.bind(this);
  }

  handleWrongSKUsDismiss() {
    this.setState({
      isLoading: false,
      showWrongSKUsModal: false,
    });
  }

  async handleWrongSKUsConfirm(updatedSKUs) {
    const { highlightedSkus, onChange, productCode } = this.props;
    onChange({
      target: {
        name: 'highlightedSkus',
        value: { ...highlightedSkus, [productCode]: updatedSKUs },
      },
    });
    this.setState({ showWrongSKUsModal: false });
    await this.props.campaignSave({ preventDefault() {} });
    await this.handleStatusChange();
  }

  handleStatusChange() {
    const { status, onStatusChange } = this.props;
    const newStatus = status === DRAFT ? READY : DRAFT;
    this.setState({ isLoading: true }, () => {
      onStatusChange(newStatus)
        .then(() => {
          this.setState({ isLoading: false });
        })
        .catch(error => {
          if (error && wrongSKUsError(error)?.includes(wrongSKUsErrorMessage)) {
            this.setState({
              wrongSKUsError: error,
              showWrongSKUsModal: true,
            });
          } else {
            this.setState({ isLoading: false });
          }
        });
    });
  }

  render() {
    const { status, overCCPLimit, productCode, isDraftCampaignEnabled } =
      this.props;
    const label = status === DRAFT ? 'Ready for Setup' : 'Move back to Draft';

    const isDisabled =
      (!isDraftCampaignEnabled && overCCPLimit) ||
      ![DRAFT, READY].includes(status);

    const { isLoading, showWrongSKUsModal } = this.state;
    return (
      <>
        <ButtonWithTooltip
          size="sm"
          color=""
          className="c-campaign-line-btn btn-white-outline shadow"
          helpKey={overCCPLimit ? 'overCCPLimit' : 'productStatusChange'}
          section="actionButtons"
          disabled={isLoading || isDisabled}
          onClick={this.handleStatusChange}
          showTooltip={isLoading || isDisabled}
        >
          {isLoading ? 'Updating…' : label}
        </ButtonWithTooltip>
        <WrongSKUsActionModal
          isOpen={showWrongSKUsModal}
          onConfirm={this.handleWrongSKUsConfirm}
          onDismiss={this.handleWrongSKUsDismiss}
          error={this.state.wrongSKUsError}
          highlightedSkus={this.props.highlightedSkus}
          productCode={productCode}
        />
      </>
    );
  }
}

ProductStatusChangeButtonClass.propTypes = {
  status: oneOf(Object.values(campaignLineStatuses)).isRequired,
  onStatusChange: func.isRequired,
  overCCPLimit: bool.isRequired,
  highlightedSkus: highlightedSkusShape,
  onChange: func.isRequired,
  productCode: string.isRequired,
  campaignSave: func.isRequired,
  isDraftCampaignEnabled: bool.isRequired,
};

ProductStatusChangeButtonClass.defaultProps = {
  highlightedSkus: {},
};

function ProductStatusChangeButton(props) {
  const isDraftCampaignEnabled = useSafeFlag(FEATURE_FLAGS.DRAFT_CAMPAIGN);
  return (
    <ProductStatusChangeButtonClass
      {...props}
      isDraftCampaignEnabled={isDraftCampaignEnabled}
    />
  );
}

export default ProductStatusChangeButton;
